import React from "react";
import classNames from "classnames";
import { Card, Spinner } from "../../../shared";
import { renderAmount } from "../../../utils";

const formatValue = (value, format) => {
  if (format === "currency") return renderAmount(value);
  if (format === "percent") return `${Number(value || 0).toFixed(1)}%`;
  return value ?? 0;
};

const KpiWidget = ({ widget, loading }) => {
  const value = widget?.data?.value;
  const format = widget?.data?.format;
  const isNegativeCurrency = format === "currency" && Number(value || 0) < 0;

  return (
    <Card className="h-full min-h-[120px] rounded-lg flex flex-col justify-between font-bold">
      <span className="text-xs md:text-sm uppercase text-gray-500">
        {widget?.title}
      </span>
      <span
        className={classNames(
          "text-center text-3xl md:text-4xl my-2 whitespace-nowrap overflow-x-auto scrollbar-hide text-emerald-500",
          {
            "!text-red-400": isNegativeCurrency,
            "!text-yellow-400": format === "currency" && Number(value || 0) === 0,
          }
        )}
      >
        {loading ? <Spinner size="md" /> : formatValue(value, format)}
      </span>
    </Card>
  );
};

export default KpiWidget;
